import { render, staticRenderFns } from "./AccessForbidden.vue?vue&type=template&id=e90efad2&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccessForbidden.vue"
export default component.exports